/* ARRAY - social proof on the product page.

   TWO POPPERS SHARE ONE SLOT AND ONE BUSY FLAG, so a review card and a sale
   card can never be on screen at the same time however the timings are tuned.
   Overlap is ruled out by the structure, not by arithmetic.

   THE SCHEDULE the client specified: first review at 3s, every card visible 3s,
   first sale at 6s, a 3s gap between cards afterwards, and 7-8s randomised
   between one sale and the next so sales stay infrequent. Each type carries its
   own next-due time; the tick shows whichever is due first and only when the
   slot is free, so a type that has to wait simply slips to the next opening.

   THE LOOP NEVER ENDS NOW (17 Sep 2026). It used to, and this was the bug the
   client reported as "the popups are not showing anymore": dismissing a card
   called setOff(kind), which wrote bdProofOff<kind> into sessionStorage, and
   has(kind) refused that type for the WHOLE BROWSING SESSION - not just that
   card, not just that page. Close the review and the sale and the proof layer
   was dead on every product page until the tab itself was closed. The client
   wants them to keep coming for as long as the shopper is on the page, so the
   cross now means "not this one": it hides the card, pushes both types out by
   one extra gap so the dismissal is respected for a beat, and the loop carries
   on. Nothing is persisted any more, and any bdProofOff* keys left over from
   the old build are cleared on load so a shopper who dismissed one earlier
   today is not still stuck.

   THE QUEUES ARE CIRCULAR - next() shifts and pushes the same item to the back -
   so a page with one review and one sale simply alternates forever. That was
   already true; it just never got the chance to prove it.

   THREE SCHEDULER BUGS ARE BURIED HERE. Do not reintroduce any of them.

   1. EVERY TIME IS MILLISECONDS SINCE THE PAGE STARTED, never a clock stamp.
      The first version mixed them - `due` began as elapsed and was reassigned
      from Date.now() after a card closed - so the next due time landed a
      trillion milliseconds away and EXACTLY ONE CARD EVER SHOWED. Keep `now()`
      on both sides of every comparison.

   2. A TIE ALTERNATES. Both types come due at the same millisecond constantly,
      because closing a card pushes both by the same gap. Breaking the tie by a
      fixed preference meant reviews won every single time and THE SALE CARD
      NEVER APPEARED AT ALL. On a tie the type that did not go last goes now.

   3. AN EARLY DISMISSAL MUST CANCEL THE DWELL TIMER. The timer is what
      rescheduled the next card; leaving it running after a manual close meant
      the schedule was still recomputed from the moment the card WOULD have
      closed, so a shopper who dismissed instantly waited the full dwell anyway.
      hide() clears it and settle() is called exactly once per card.

   CONTENT COMES FROM THE SECTION, NEVER FROM HERE. If the merchant has added no
   Review blocks and no buyers, both lists are empty and nothing is ever shown.
   This file does not carry a single name, city or quote of its own.

   THE VIEWER NUMBER IS THE ONE SIMULATION, at the client's explicit request. It
   walks inside the base band, occasionally spikes, occasionally dips to the
   floor, and never repeats the same value twice in a row. It is not a
   measurement of anything and is labelled as such in the section settings.

   IT STILL STOPS WHEN THE TAB IS HIDDEN - there is no point animating a card
   nobody is looking at, and it keeps the schedule honest when they come back. */
(function () {
  if (window.__bdProofBound) return;
  window.__bdProofBound = true;

  /* the old build could leave a type switched off for the whole session */
  try {
    sessionStorage.removeItem('bdProofOffreview');
    sessionStorage.removeItem('bdProofOffsale');
  } catch (e) {}

  function parse(el) { try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; } }
  function rnd(a, b) { return Math.floor(Math.random() * (b - a + 1)) + a; }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }

  /* ---------------- the popper ---------------- */
  function startProof(root) {
    if (root.__on) return;
    root.__on = true;

    var reviews = parse(root.querySelector('[data-bp-reviews]'));
    var sales = parse(root.querySelector('[data-bp-sales]'));
    var whenEl = root.querySelector('[data-bp-when]');
    var whenTpl = whenEl ? whenEl.textContent.trim() : '';

    var secs = function (k, d) { var n = parseFloat(root.getAttribute(k)); return isNaN(n) ? d : n; };
    var first = secs('data-first', 3) * 1000;
    var dwell = secs('data-dwell', 3) * 1000;
    var gap = secs('data-gap', 3) * 1000;
    var smin = secs('data-smin', 7) * 1000;
    var smax = secs('data-smax', 8) * 1000;
    if (smax < smin) smax = smin;

    if (!reviews.length && !sales.length) return;

    var queue = { review: reviews.slice(), sale: sales.slice() };
    var due = { review: first, sale: first + dwell };
    var busy = false;
    var card = null;
    var last = '';
    var timer = null;
    var settled = true;
    var t0 = Date.now();
    function now() { return Date.now() - t0; }

    function has(kind) { return queue[kind].length > 0; }
    function next(kind) {
      var q = queue[kind];
      var item = q.shift();
      q.push(item);
      return item;
    }

    function stars(n) {
      var out = '';
      for (var i = 1; i <= 5; i++) out += '<i' + (i <= n ? '' : ' class="is-off"') + '></i>';
      return out;
    }

    /* one card, one settle: push both types out and free the slot */
    function settle(kind, extra) {
      if (settled) return;
      settled = true;
      var closed = now();
      if (kind === 'sale') {
        due.sale = closed + rnd(smin, smax) + extra;
        due.review = Math.max(due.review, closed + gap + extra);
      } else {
        due.review = closed + gap + extra;
        due.sale = Math.max(due.sale, closed + gap + extra);
      }
    }

    function build(kind, d) {
      var el = document.createElement('div');
      el.className = 'bp-card';
      var meta = [];
      if (d.who) meta.push(esc(d.who));
      if (d.place) meta.push(esc(d.place));
      if (kind === 'review' && d.when) meta.push(esc(d.when));
      if (kind === 'sale' && whenTpl) meta.push(esc(whenTpl.split('{n}').join(String(rnd(3, 48)))));

      var ava = kind === 'sale' && d.img
        ? '<span class="bp-ava"><img src="' + esc(d.img) + '" alt="" width="38" height="38" loading="lazy"></span>'
        : '<span class="bp-ava">' + esc((d.who || '?').charAt(0).toUpperCase()) + '</span>';

      var main = kind === 'review'
        ? '<p class="bp-q">' + esc(d.quote) + '</p>'
        : '<p class="bp-t">' + (d.url ? '<a href="' + esc(d.url) + '">' + esc(d.title) + '</a>' : esc(d.title)) + '</p>';

      el.innerHTML = ava +
        '<span class="bp-body">' +
          '<span class="bp-top">' +
            '<span class="bp-eye"><span class="bp-dot"></span>' + esc(d.eyebrow || '') + '</span>' +
            (kind === 'review' ? '<span class="bp-stars">' + stars(d.stars || 5) + '</span>' : '') +
          '</span>' + main +
          (meta.length ? '<p class="bp-m">' + meta.join(' &middot; ') + '</p>' : '') +
        '</span>' +
        '<button type="button" class="bp-x" aria-label="Dismiss">&times;</button>';

      /* the cross means "not this one", not "never again" */
      el.querySelector('.bp-x').addEventListener('click', function () {
        settle(kind, gap);
        hide();
      });
      return el;
    }

    function hide() {
      if (timer) { clearTimeout(timer); timer = null; }
      if (!card) { busy = false; return; }
      var gone = card;
      card = null;
      busy = false;
      gone.classList.remove('is-in');
      setTimeout(function () { if (gone.parentNode) gone.parentNode.removeChild(gone); }, 500);
    }

    function show(kind) {
      var d = next(kind);
      if (!d) { busy = false; return; }
      busy = true;
      settled = false;
      last = kind;
      card = build(kind, d);
      root.appendChild(card);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { if (card) card.classList.add('is-in'); });
      });

      timer = setTimeout(function () {
        timer = null;
        settle(kind, 0);
        hide();
      }, dwell);
    }

    setInterval(function () {
      if (busy || document.hidden) return;
      var t = now();
      var r = has('review') && t >= due.review;
      var s = has('sale') && t >= due.sale;
      if (!r && !s) return;
      if (!r) { show('sale'); return; }
      if (!s) { show('review'); return; }
      if (due.review !== due.sale) show(due.review < due.sale ? 'review' : 'sale');
      else show(last === 'review' ? 'sale' : 'review');
    }, 250);
  }

  /* ---------------- the simulated viewer line ---------------- */
  function startLive(el) {
    if (el.__on) return;
    el.__on = true;

    var num = function (k, d) { var n = parseInt(el.getAttribute(k), 10); return isNaN(n) ? d : n; };
    var a = num('data-a', 7), b = num('data-b', 9);
    var sa = num('data-sa', 17), sb = num('data-sb', 19);
    var floor = num('data-floor', 5);
    if (b < a) b = a;
    if (sb < sa) sb = sa;

    var out = el.querySelector('[data-pdp-live-n]');
    var cur = rnd(a, b);
    var mode = 'base';
    var left = rnd(3, 6);

    el.hidden = false;
    if (out) out.textContent = String(cur);

    function paint(v) {
      cur = v;
      el.classList.add('is-tick');
      setTimeout(function () {
        if (out) out.textContent = String(v);
        el.classList.remove('is-tick');
      }, 220);
    }

    function step() {
      left--;
      if (left <= 0) {
        var roll = Math.random();
        if (mode !== 'base') { mode = 'base'; left = rnd(4, 9); }
        else if (roll < 0.16) { mode = 'spike'; left = rnd(2, 4); }
        else if (roll < 0.26) { mode = 'dip'; left = rnd(1, 3); }
        else { left = rnd(3, 7); }
      }
      var lo = a, hi = b;
      if (mode === 'spike') { lo = sa; hi = sb; }
      if (mode === 'dip') { lo = floor; hi = floor + 1; }

      var v = cur;
      var guard = 0;
      while (v === cur && guard < 12) { v = rnd(lo, hi); guard++; }
      paint(v);
      setTimeout(step, rnd(2600, 6200));
    }
    setTimeout(step, rnd(2600, 5200));
  }

  function init() {
    var roots = document.querySelectorAll('[data-bd-proof]');
    for (var i = 0; i < roots.length; i++) startProof(roots[i]);
    var live = document.querySelectorAll('[data-pdp-live]');
    for (var j = 0; j < live.length; j++) startLive(live[j]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
